export default "__VITE_ASSET__C8YpHpUS__"